// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabGdprListaSocios extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.gdpr_lista_socios";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabGdprListaSocios {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Se listen over leverandører",
                "de": "Siehe Liste der Mitglieder",
                "en": "See list of vendors",
                "fr": "Liste de nos partenaires",
                "it": "Vedere lista di partner",
                "nl": "Lijst met leden inzien",
                "pt": "Ver lista de sócios",
                "ru": "См. список партнёров",
                "pt-BR": "Veja a lista de parceiros"
            },
            "defecto": "Ver lista de socios"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
